export default __webpack_public_path__ + "static/media/jeadee_img2.44e7adf6.webp";